import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '../src/assets/fonts/material-icon/css/material-design-iconic-font.min.css'
// import './components/setup/sidebarmenu.js'

const app = createApp(App)
app.use(router)
app.mount('#app')
